class Cart extends HTMLElement {
  constructor() {
    super();

    this.addListeners();
    this.cartCounters = document.querySelectorAll('.js-cart-counter');
  }

  cartAddUnsubscriber = undefined;
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartAddUnsubscriber = subscribe(PUB_SUB_EVENTS.cartAdd, () => {
      this.renderCart();
    });

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.renderCart();
    });
  }

  disconnectedCallback() {
    if (this.cartAddUnsubscriber) {
      this.cartAddUnsubscriber();
    }

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  handleInputChange(input, key) {
    this.classList.add("cart__section--loading");

    let lineKey = key;
    let quantity = 0;

    if (input && input.getAttribute("data-key")) {
      lineKey = input.getAttribute("data-key");
    }

    if (input && input.value) quantity = parseInt(input.value);

    if (lineKey && quantity >= 0) {
      const body = JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: "cart-main",
      });

      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
        .then(response => response.text())
        .then(text => {
          let sectionHtml = JSON.parse(text).sections["cart-main"];

          this.renderCart(sectionHtml);
        })
        .catch(e => console.error(e));
    } else {
      this.classList.remove("cart__section--loading");

      console.error("No line item details.");
    }
  }

  renderCart(response) {
    this.classList.add("cart__section--loading");

    if (response) this.updateCart(response)
    else {
      fetch("/?section_id=cart-main")
        .then(response => response.text())
        .then(response => this.updateCart(response));
    }
  }

  updateCart(response) {
    const html = document.createElement("div");

    html.innerHTML = response;

    const form = html.querySelector(".js-cart-form");

    this.renderFunctions(html, form);
    this.addListeners();
  }

  renderFunctions(html, form) {
    this.classList.remove("cart__section--loading");

    if (form) {
      this.updateSummary(html);
      this.updateItems(html);
      this.updateTotal(html);
      this.updateUpsells(html);
    }

    if (!form) this.renderCartEmpty(html);
  }

  updateSummary(html) {
    const summary = this.querySelector(".js-cart-summary");
    const newSummary = html.querySelector(".js-cart-summary");

    if (summary && newSummary) summary.innerHTML = newSummary.innerHTML;
  }

  updateItems(html) {
    const items = this.querySelector(".js-cart-items");
    const newItems = html.querySelector(".js-cart-items");

    if (items && newItems) items.innerHTML = newItems.innerHTML;
  }

  updateTotal(html) {
    const total = this.querySelector(".js-cart-total");
    const newTotal = html.querySelector(".js-cart-total");

    if (total && newTotal) total.innerHTML = newTotal.innerHTML;

    if (this.cartCounters) {
      if(html.querySelector('[data-cart-item-count]')) {
        this.cartCounters.forEach(el => el.innerHTML = html.querySelector('[data-cart-item-count]').value);
      }
    }
  }

  updateUpsells(html) {
    const init = this.dataset.upsellsInit === "true";
    const cartSection = html.querySelector(".js-cart-section");
    const upsells = this.querySelectorAll("recommended-products");
    const id = cartSection.dataset.upsellsId;

    upsells.forEach(upsell => upsell.dataset.product = id);

    if (init) publish(PUB_SUB_EVENTS.upsellsUpdate);
  }

  renderCartEmpty(html) {
    const empty = html.querySelector('.js-cart-section');

    if (empty) this.innerHTML = empty.innerHTML;
  }

  addListeners() {
    const form = this.querySelector(".js-cart-form");

    if (form) {
      this.quantityInputs = form.querySelectorAll(".js-cart-quantity");
      this.removeButtons = form.querySelectorAll(".js-cart-remove");

      if (this.quantityInputs) {
        this.quantityInputs.forEach(input =>
          input.addEventListener("change", this.handleInputChange.bind(this, input))
        );
      }

      if (this.removeButtons) {
        this.removeButtons.forEach(input =>
          input.addEventListener("click", event => {
            event.preventDefault();

            this.handleInputChange(null, input.getAttribute("data-key"));
          })
        );
      }
    }
  }
}

customElements.define("cart-section", Cart);
